import React, {useEffect, useState} from "react";
import {useActions} from "../../hook/useActions";
import {useTypedSelector} from "../../hook/useTypedSelector";
import styles from "./YearCalendar.module.scss";
import {convertFromDST, DateTimeObject} from "./dstToLtConverter";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {ekadasi} from "../../constants/ekadasi-list";



export function getBreakFastTime(day: any): string {
    if (day.events[0].text.includes("(LT)")) {
        return day.events[0].text.replace("Break fast ", "").replace(" (LT)", "").replace("after ", "Після ");
    }

    const baseDate = {
        day: day.date.day,
        month: day.date.month,
        year: day.date.year,
    };

    if (day.events[0].text.includes("after")) {
        const timeInterval = day.events[0].text.replace("Break fast ", "").replace(" (DST)", "").replace("after ", "");
        const time: DateTimeObject = {
            ...baseDate,
            time: timeInterval
        }
        return "Після " + convertFromDST(time).time;
    }

    if (!day.events[0].text.includes("after")) {
        let timeInterval = day.events[0].text.replace("Break fast ", "").replace(" (DST)", "").split(" - ");


        const [time1, time2] = timeInterval.map((time: string) => ({
            ...baseDate,
            time,
        }));

        return (convertFromDST(time1).time + " - " + convertFromDST(time2).time);
        // res = (convertFromDST(time1).time + " - " + convertFromDST(time2).time + "___________ (" + timeInterval[0] + " - " + timeInterval[1] + ")");
    }
    return day.events[0].text;
}

const FullYearCalendar = (): JSX.Element => {
    const {GetYearCalendar} = useActions();
    const [ekadashiList, setEkadashiList] = useState<any[]>();
    const [groupedByMonth, setGroupedByMonth] = useState<any[]>();

    const {yearCalendar} = useTypedSelector((state) => state.calendar);

    const [searchParams] = useSearchParams();
    const {t, i18n} = useTranslation();

    // const valuablePhases = [3, 8, 9, 14]
    const country = searchParams.get("country");
    const city = searchParams.get("city");
    const year = Number(searchParams.get("year"));

    useEffect(() => {
        document.title = 'Ekadasi ' + country + " " + city + " " + year;
        const data = {
            city: city,
            country: country,
            period: new Date(year, 1, 29).getDate() === 29 ? 366 : 365,
            year: year,
            month: 1,
            day: 1
        }
        GetYearCalendar(data);
    }, [city, country, year]);

    useEffect(() => {
        if (!yearCalendar)
            return;

        setEkadashiList(removeLastAdjacentDuplicate(yearCalendar.days));

        const groupByMonth = yearCalendar.days.reduce((acc: any, day: any) => {
            if (!acc[day.date.month]) {
                acc[day.date.month] = [];
            }
            acc[day.date.month].push(day);
            return acc;
        }, {})
        setGroupedByMonth(groupByMonth);
    }, [yearCalendar]);

    if(!yearCalendar || yearCalendar.count < 300 || yearCalendar.days[0].date.year !== year)
        return (
            <div className={"text-center"}>Calculating, please wait...</div>
        );

    return (<>
        <h1 className={"text-center " + styles.title}>{t("FullYearCalendar.Title")}<span>{year}</span> {t("FullYearCalendar.year")}</h1>
        <div className={styles.tablesContainer} style={{fontSize: 25}}>
            <div className="row">
                <div className="col-md-6">
                    <div className="container">
                        <table className={"table table-bordered"}>
                            <thead>
                            <tr className={"text-center"}>
                                <th className={"align-middle"}>{year - 2000}{t("FullYearCalendar.th")} {t("FullYearCalendar.year")}</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>01</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>02</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>03</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>04</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>05</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>06</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>07</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>08</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>09</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>10</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>11</th>
                                <th className={"col-1 align-middle " + styles.tableColumn}>12</th>
                            </tr>
                            </thead>
                            <tbody>
                            {groupedByMonth && [...Array(Math.max(...Object.values(groupedByMonth).map((month) => month.length)))].map((_, dayIndex) => (
                                <tr key={dayIndex} className={"text-center"} style={{height: 40}}>
                                    <td className={styles.dayNumber}>{(dayIndex + 1 < 10 ? "0" : "") + (dayIndex + 1)}</td>
                                    {Object.keys(groupedByMonth).map((month: any) => {
                                        const dayData = groupedByMonth[month][dayIndex];
                                        if (!dayData)
                                            return (<td></td>);
                                        // const isValuablePhase = valuablePhases.findIndex((phase) => phase === dayData.astrodata.tithi % 15 + 1) !== -1;
                                        if (ekadashiList?.findIndex((x) => x.date === dayData.date) !== -1) {
                                            return (
                                                <td key={month}
                                                    className={styles.dayCell + " text-center align-middle " + (dayData.astrodata.tithi > 14 ? styles.L : styles.D)}>
                                                    <img src={"images/miniLogo.png"} alt={"11"}/>
                                                </td>
                                            );
                                        }
                                        if (dayData.astrodata.tithi % 15 === 14) {
                                            return (
                                                <td key={month}
                                                    className={"text-center align-middle " + styles.dayCell + " " + (dayData.astrodata.tithi > 14 ? styles.fullMoon : styles.newMoon)}>
                                                    {dayData.astrodata.tithi > 14 ? t("FullYearCalendar.F") : t("FullYearCalendar.N")}
                                                </td>
                                            );
                                        }
                                        if (dayData.astrodata.tithi > 14) {
                                            return (
                                                <td key={month}
                                                    className={"text-center align-middle " + styles.dayCell + " " + styles.L}>
                                                    {t("FullYearCalendar.L")}{(dayData.astrodata.tithi % 15 + 1)}
                                                </td>
                                            );
                                        } else {
                                            return (
                                                <td key={month}
                                                    className={"text-center align-middle " + styles.dayCell + " " + styles.D}>
                                                    {t("FullYearCalendar.D")}{(dayData.astrodata.tithi % 15 + 1)}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>


                <div className="col">
                    <div className="container">
                        <table className="table table-bordered">
                            <thead>
                            <tr className="text-center">
                                <th className={styles.tableColumn} rowSpan={2}>№</th>
                                <th className={styles.tableColumn} rowSpan={2}>{t("FullYearCalendar.EnterDay")}</th>
                                <th className={styles.tableColumn} rowSpan={2}>{t("FullYearCalendar.EkadashiName")}</th>
                                <th className={styles.ekadashiTableColumTop} colSpan={2}>{t("FullYearCalendar.ExitDay")}</th>
                            </tr>
                            <tr className="text-center">
                                <th className={styles.ekadashiTableColumBot}>
                                    <div className={styles.gradientText}>{t("Countries." + country).includes("Countries.") ? country : t("Countries." + country)}</div>
                                </th>
                                <th className={styles.ekadashiTableColumBot}>
                                    <div className={styles.gradientText}>{t("Cities." + city).includes("Cities.") ? city : t("Cities." + city)}</div>
                                </th>
                            </tr>

                            </thead>
                            <tbody className={styles.ekadashiList}>
                            {ekadashiList && ekadashiList.map((row, index) => (
                                <tr key={index} className="text-center align-middle">
                                    <td>{ekadasi.findIndex((x) => x === row.ekadashiName.replace(' Ekadasi', '')) + 1}</td>
                                    <td>{(row.date.day < 10 ? "0" : "") + row.date.day + "." + (row.date.month < 10 ? "0" : "") + row.date.month}</td>
                                    <td>{t("Ekadasi." + row.ekadashiName.replace(' Ekadasi', ''))}</td>
                                    <td>{(row.endDate.day < 10 ? "0" : "") + row.endDate.day + "." + (row.endDate.month < 10 ? "0" : "") + row.endDate.month}</td>
                                    <td>{row.events && getBreakFastTime(row)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div className={"text-center " + styles.quote}>{t("FullYearCalendar.Footer")} <span>{t("FullYearCalendar.FooterQuoteAuthor")}</span></div>
        <div className={styles.allMoons}><img src={"/locales/" + i18n.language + "/images/moons-full-year.png"} alt={"moons hint"}/></div>
        <div className={styles.reference}><a href={"http://vedaem.com.ua/"}><img src={"images/logo.png"} alt={"Logo"}/>http://vedaem.com.ua/</a>
        </div>
    </>);
}


export function removeLastAdjacentDuplicate(array: any[]): any[] {
    const result: any[] = [];
    let lastEkadasiIndex = -1;

    for (let i = 0; i < array.length; i++) {
        if (lastEkadasiIndex === -1 && array[i].ekadashiName !== "") {
            lastEkadasiIndex = i;
            continue;
        }
        if (lastEkadasiIndex !== -1) {
            const ekadasi = {
                ...array[lastEkadasiIndex],
                events: array[i].events,
                endDate: array[i].date,
                duration: i - lastEkadasiIndex
            };
            result.push(ekadasi);
            lastEkadasiIndex = -1;
        }
    }

    return result;
}

export default FullYearCalendar;